import React from "react";
import { Helmet } from "react-helmet";

const MetaRobots = () => {
  const { origin } = window.location;
  const matchOrigin = origin === "https://www.jibjab.com";

  return (
    !matchOrigin && (
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
    )
  );
};

export default MetaRobots;
